import React from 'react';
import { reducer, initialState, IState } from './reducer';
import {
  addGroupOrderGoods,
  setGroupOrderCartData,
  setGroupOrderData,
  setIntervalGroupOrderData,
  subGroupOrderGoods,
  setFreeShippingProgress
} from './actions';

export const GroupOrderContext = React.createContext<{
  state: any;
  dispatch: React.Dispatch<any>;
}>({
  state: initialState,
  dispatch: () => null
});

export const GroupOrderProvider: React.FC<{
  data?: any;
}> = ({ children, data }) => {
  const [state, dispatch] = React.useReducer(reducer, { ...initialState, ...data });

  return <GroupOrderContext.Provider value={{ state, dispatch }}>{children}</GroupOrderContext.Provider>;
};

interface IGroupStore extends IState {
  setGroupOrderCartData: (payload: any) => void;
  setGroupOrderData: (payload: any) => void;
  setIntervalGroupOrder: (payload: any) => void;
  addGroupOrderGoods: (payload: any) => void;
  subGroupOrderGoods: (payload: any) => void;
  setFreeShippingProgress: (payload: any) => void;
}

export const useGroupOrder = (): IGroupStore => {
  const { dispatch, ...rest } = React.useContext(GroupOrderContext);
  //如果不存在provider

  return {
    ...rest.state,
    setGroupOrderCartData: payload => {
      dispatch(setGroupOrderCartData(payload));
    },
    setGroupOrderData: payload => {
      dispatch(setGroupOrderData(payload));
    },
    setIntervalGroupOrder: payload => {
      dispatch(setIntervalGroupOrderData(payload));
    },
    addGroupOrderGoods: payload => {
      dispatch(addGroupOrderGoods(payload));
    },
    subGroupOrderGoods: payload => {
      dispatch(subGroupOrderGoods(payload));
    },
    setFreeShippingProgress: payload => {
      dispatch(setFreeShippingProgress(payload));
    }
  };
};
